import { DateTime } from 'luxon';

export function initialState() {
    return {
        recentVenues: [],
        isFilled: false,
        clubUsers: [],
        clubSquads: [],
        exercises: [],
        seat_racing: false,
        details: {
            name: '',
            sessionType: null,
            session_id: null,
            all_day_event: false,
            attendance_limit: null,
            planned_rpe: null,
            startDate: DateTime.now().toISO(),
            startTime: DateTime.now().set({ hour: 7, minute: 0 }).toISO(),
            endDate: DateTime.now().toISO(),
            endTime: DateTime.now().set({ hour: 8, minute: 30 }).toISO(),
            totalDistance: '',
            totalTime: '',
            location: {},
            description: '',
            weather: '',
            focuses: [],
            intensities: [],
            stroke_rate_intensities_paddling: [],
            stroke_rate_intensities_rowing: [],
            heart_rate_intensities: [],
            tags: [],
            repeat: {
                checked: null,
                editing: false,
                repeat_frequency_type: null,
                repeat_every: 1,
                repeat_on_the_specific_step: null,
                repeat_on_the_specific_every: null,
                repeat_end_date: null,
                repeat_numbers: null,
                repeat_on_the_specific_days: []
            }
        },

        attendance: {
            creatorId: null,
            athletes: {},
            coaches: {},
            coach_permissions: {},
            athlete_permissions: {}
        },

        work: {
            createPieces: false,
            repetitions: null,
            pieceTypes: {
                single: true,
                multiple: false,
                variable: false
            },
            pieces: [
                {
                    distance: null,
                    time: null,
                    split_length: null,
                    variable_split_lengths: [],
                    rest: null
                }
            ],
            scStructures: []
        }
    };
}
